export const TextWidgetId = 'TextWidget';

export enum TextWidgetAttributes {
  TEXT = 'text',
  ID = 'textWidgetId',
  GRAY = 'backgroundGray',
}
